module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="names-picker">\n\n    <div class="heading">\n    Names Selection\n    </div>\n\n    <div class="grid-container">\n        <div class="grid-70">\n            <div class="filter-box grid-container">\n                <div class="filter-hook grid-25"></div>\n                <button class="button button-secondary add-filtered">\n                    Add Filtered\n                </button>\n                <div class="clearfix"></div>\n            </div>\n            <div class="all-hook"></div>\n            <div class="paginator-hook"></div>\n        </div>\n        <div class="grid-30">\n            <div class="group-hook">\n                <button class="button button-secondary add-group">\n                    Add Group\n                </button>\n            </div>\n            \n            <div class="selected-items-hook"></div>\n        </div>\n    </div>\n\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/contacts/layout.html
// module id = 264
// module chunks = 0